export default {
  "custom": {
    linkedReference: 'ارجاع مرتبط',
    boot: 'روشن',
    shutDown: 'خاموش',
    notLinked: 'نامرتبط',
    maxLinkedTip: 'حداکثر ۲ ارتباط {type} مجاز است، به طور خودکار به نامرتبط بازگردانده شد',

    bar_Power: 'برق',
    bar_Video: 'تعویض ویدیو',
    bar_Vol: 'صدا',
    bar_Audio: 'تعویض صدا',
    bar_Serial: 'کنترل سریال',
    bar_Air: 'تهویه مطبوع',
    bar_Projection: 'پرده نمایش',
    bar_Remote: 'کنترل از راه دور',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'باید هر سه تصویر را همزمان انتخاب کنید',
    notSelected: 'انتخاب نشده',
    choose: 'انتخاب کنید',
    disable: 'غیرفعال کردن',
    "longPressAndDrag": "برای تغییر ترتیب فهرست، نگه دارید و بکشید",
    "isrestoreDefault": "آیا می‌خواهید به حالت پیش‌فرض بازگردید؟",
    "saveAndSync": "ذخیره و همگام‌سازی",
    "restoreDefault": "بازگرداندن پیش‌فرض",
    "limitPNG": "فقط تصاویر PNG قابل بارگذاری هستند!",
    "limit1M": "اندازه تصویر نباید بیش از ۱ مگابایت باشد!",
    "selectTheImage": "انتخاب تصویر",
    "textsuggestions": "توصیه می‌شود: آیکون PNG سفید 48*48 پیکسل، کمتر از ۱ مگابایت",
    "iconLibrary": "کتابخانه آیکون",
    "panelNavigationBarCustomization": "نوار ناوبری پنل",
    "logoCustomization": "لوگوی پنل"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'Binding failed: This Microsoft tenant (ID: ',
    AuthVerify4004Two: ") is already occupied by the organization [",
    AuthVerify4004Three: "].To rebind, please first unbind it from the original organization or use a different Microsoft tenant.",
    theMicrosoftTenantIsOccupied: 'The Microsoft tenant is occupied',
    Viewtutorial: 'آموزش اتصال را مشاهده کنید',
    checktenantID: 'لطفاً بررسی کنید که شناسه مستاجر، شناسه برنامه و کلید برنامه شما صحیح باشد.',
    ErrorCode: 'کد خطا:',
    AuthorizationFailed: 'مجوزدهی ناموفق بود',
    Accesshasbeengranted: 'دسترسی به Microsoft Graph API با موفقیت اعطا شد',
    successfullyauthorizedDescribe: 'مجوزهای مورد نیاز با موفقیت صادر شد. داده‌های اتاق جلسات به صورت خودکار همگام‌سازی خواهند شد. لطفاً این صفحه را ببندید.',
    Close: 'بستن',
    resourceID: 'شناسه منبع',
    dialogTips: 'راهنمایی',
    theAuthorizationIsDeleted: 'مجوز حذف شد',
    theBindingIsSuccessful: 'اتصال موفقیت‌آمیز بود',
    theUnbindingIsSuccessful: 'قطع اتصال موفقیت‌آمیز بود',
    unbindingFailed: 'قطع اتصال ناموفق بود',
    theUnbindingHasBeenUnbound: 'قطع اتصال لغو شد',
    continueUnbinding: 'همگام‌سازی Outlook متوقف شده و تمام رویدادهای آینده پاک خواهند شد. آیا ادامه می‌دهید؟',
    areYouSureAboutUnbinding: 'تمام رویدادهای آینده Outlook پاک شده و همگام‌سازی متوقف خواهد شد. این عمل غیرقابل بازگشت است. آیا قطع اتصال را تأیید می‌کنید؟',
    UnbindNotSynchronized: 'پس از اتصال، رویدادهای جدید Outlook برای این اتاق به صورت خودکار همگام‌سازی می‌شوند (رویدادهای گذشته همگام‌سازی نمی‌شوند)',
    unbinding: 'قطع اتصال',
    bindUnableToSelect: 'قبلاً متصل شده، امکان انتخاب وجود ندارد',
    permissAThird: 'لطفاً برای اتصال منابع شخص ثالث مجوز دهید',
    resourceMailbox: 'صندوق پستی منبع:',
    PleasecheckID: 'مجوزدهی ناموفق! لطفاً بررسی کنید که شناسه مستاجر، شناسه برنامه و رمز مشتری شما صحیح باشد.',
    Waitingforauthorization: 'در انتظار مجوزدهی...',
    Pleasecompletetheauthorization: 'صفحه ورود Microsoft 365 باز شد. لطفاً با حساب مدیر وارد شوید تا مجوزدهی تکمیل شود.',
    pleaseEnterTheTenantID: 'لطفاً شناسه مستاجر را وارد کنید',
    pleaseEnterTheClientID: 'لطفاً شناسه برنامه را وارد کنید',
    pleaseEnterTheClientSecret: 'لطفاً رمز مشتری را وارد کنید',
    Authorizationcompleted: 'مجوزدهی تکمیل شد',
    Authorizelogin: 'ورود Microsoft 365 را مجوز دهید',
    ApplicationID: 'شناسه مستاجر',
    ClientID: 'شناسه برنامه',
    ClientSecret: 'رمز مشتری',
    registTipOne: 'لطفاً از',
    registTipTwo: 'راهنمای اتصال',
    registTipThree: 'پیروی کنید. ثبت برنامه در Azure و تنظیمات مجوزها را قبل از پر کردن فیلدهای زیر کامل کنید.',
    MicrosoftDescribe: 'با اتصال Microsoft 365، جلسات رزرو شده در Outlook/Teams به صورت خودکار با کنسول Q-NEX و برنامه‌ریز اتاق همگام‌سازی می‌شوند.',
    Addcalendarservice: 'تنظیمات همگام‌سازی تقویم',
    Lasttimesynchronization: 'آخرین زمان همگام‌سازی',
    Allocated: 'اختصاص یافته',
    Total: 'مجموع',
    Conferenceroomresources: 'منابع اتاق جلسات',
    Bindingtime: 'زمان اتصال',
    Bindtheplatform: 'پلتفرم اتصال',
    Synchronousstate: 'وضعیت همگام‌سازی',
    Organizationname: 'نام سازمان',
    Bindthirdpartycalendar: 'اتصال تقویم شخص ثالث',
    TenantIDTip: 'شناسه منحصربفرد در Azure AD',
    ApplicationIDTip: 'شناسه برنامه ثبت شده در Azure',
    ApplicationSecretTip: 'رمز مشتری تولید شده در Azure برای احراز هویت'
  },
  "meetingManager": {
    IdleDisplayTextTable: 'متن نمایش حالت بیکار',
    IdleDisplayText: 'متن نمایش حالت بیکار:',
    IdleDisplayTextContent: 'متنی که هنگام خالی بودن اتاق نمایش داده می‌شود (پیش‌فرض: «خالی»)',

    duplicateMeetingRoomName: 'نام اتاق جلسه تکراری است',
    duplicateMeetingRoomNameContent: 'اتاق جلسه‌ای با نام "{duplicate_content}" از قبل وجود دارد. لطفاً نام دیگری وارد کنید.',
    NumberOfRoomPanels: 'تعداد پنل‌های اتاق',
    "Thecurrentterminalhasbeenboundtoanotherorganization": " ترمینال فعلی قبلاً به یک سازمان دیگر متصل شده است.",
    "theTerminalNameOrIDIsDuplicated": "نام یا شناسه پنل یکسان است",
    theRoomNameOrIDIsDuplicated: 'نام اتاق جلسه یا محل تکراری است.',
    "AddMeetingRoom": "افزودن اتاق کنفرانس",
    "EditMeetingRoom": "ویرایش اتاق کنفرانس",
    "MeetingRoomName": "نام اتاق کنفرانس:",
    "Location": "مکان:",
    "ReservationApproval": "تایید رزرو:",
    "ApprovalListYes": "بله",
    "ApprovalListNo": "نه",
    "Capacity": "ظرفیت:",
    "RoomStatus": "وضعیت اتاق:",
    "BindRoomDisplay": "اتصال پنل اتاق:",
    "meeting_btnAdd": "افزودن",
    "meeting_btnEdit": "ویرایش",
    "meeting_btnBind": "اتصال دستگاه",
    "meeting_btnDel": "حذف",
    "meeting_tableRoomName": "نام اتاق کنفرانس",
    "meeting_tableRoomPlace": "مکان",
    "meeting_tableAppointmentApproval": "تایید رزرو",
    "meeting_tableCapacityForPeople": "ظرفیت",
    "meeting_tableMeetingRoomStatus": "وضعیت اتاق",
    "meeting_tableAvaliable": "در دسترس",
    "meeting_tableOutofService": "خارج از سرویس",
    "meeting_tableDoorBind": "اتصال درب",
    "meeting_tableBindNPS": "اتصال NPS",
    "meeting_tableActions": "اقدامات",
    "door_theNameOfTheTerminal": "نام پنل:",
    "door_deviceID": "شناسه پنل:",
    "door_Wallpaper": "تصویر پس‌زمینه:",
    "door_Wallpaper_text": "تصویر پیشنهادی: اندازه 1280x800، فرمت PNG",
    "door_bindAMeetingRoom": "اتصال اتاق کنفرانس:",
    "door_table_name": "نام پنل",
    "door_table_deviceID": "شناسه پنل",
    "door_table_status": "وضعیت",
    "door_table_ipAddress": "آدرس IP",
    "door_table_bindAMeetingRoom": "اتصال اتاق کنفرانس",
    "door_btnAdd": "افزودن",
    "door_btnBatchAdd": "افزودن گروهی",
    "door_btnEdit": "ویرایش",
    "door_btnBatchEdit": "ویرایش گروهی"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "افزودن پیکربندی",
    "configurationEditTitle": "ویرایش پیکربندی",
    "dialogConfigName": "نام پیکربندی",
    "selectNMPAndNDP": "دستگاه‌های هدف",
    "powerControl": "کنترل انرژی",
    "executeCommand": "انجام دهید",
    "tableConfigName": "نام پیکربندی",
    "selectConfig": "لطفاً پیکربندی را انتخاب کنید"
  },
  "NPS": {
    "Relay": "رله",
    "RelaySettings": "تنظیمات رله",
    "DevicePower": "کنترل انرژی دستگاه",
    "DeviceElevation": "کنترل ارتفاع",
    "LinageWithNPSPower": "ارتباط با انرژی NPS",
    "PresentationSwitch": "سوئیچ نمایش",
    "Duplicate": "کپی",
    "LinkagewithNPSPowe": "ارتباط با انرژی NPS"
  },
  "PTZ": {
    "powerSupplyON": "روشن",
    "powerSupplyOFF": "خاموش",
    "LEFT": "چپ",
    "RIGHT": "راست",
    "UP": "بالا",
    "DOWN": "پایین",
    "HOME": "خانه",
    "ENLARGE": "بزرگ‌نمایی",
    "REDUCTION": "کوچک‌سازی",
    "StopMovement": "توقف حرکت",
    "STOP": "توقف زوم",
    "FOCUS": "فوکوس",
    "SET_PRESETS0": "تنظیم پیش‌فرض0",
    "SET_PRESETS1": "تنظیم پیش‌فرض1",
    "SET_PRESETS2": "تنظیم پیش‌فرض2",
    "SET_PRESETS3": "تنظیم پیش‌فرض3",
    "SET_PRESETS4": "تنظیم پیش‌فرض4",
    "SET_PRESETS5": "تنظیم پیش‌فرض5",
    "SET_PRESETS6": "تنظیم پیش‌فرض6",
    "SET_PRESETS7": "تنظیم پیش‌فرض7",
    "SET_PRESETS8": "تنظیم پیش‌فرض8",
    "SET_PRESETS9": "تنظیم پیش‌فرض9",
    "USE_PRESETS0": "استفاده از پیش‌فرض0",
    "USE_PRESETS1": "استفاده از پیش‌فرض1",
    "USE_PRESETS2": "استفاده از پیش‌فرض2",
    "USE_PRESETS3": "استفاده از پیش‌فرض3",
    "USE_PRESETS4": "استفاده از پیش‌فرض4",
    "USE_PRESETS5": "استفاده از پیش‌فرض5",
    "USE_PRESETS6": "استفاده از پیش‌فرض6",
    "USE_PRESETS7": "استفاده از پیش‌فرض7",
    "USE_PRESETS8": "استفاده از پیش‌فرض8",
    "USE_PRESETS9": "استفاده از پیش‌فرض9"
  },
  "schedule": {
    "startLinkPowerStart": "روشن (رله CBX)",
    "startLinkPowerStop": "خاموش (رله CBX)",
    "dehumidification": "خشک",
    "airSupply": "فن",
    "masterControl": "اصلی:",
    "powerSupply": "قدرت",
    "lockScreen": "قفل",
    "RecordingControl": "کنترل ضبط",
    "RecordingControlSystem": "سیستم ضبط سخنرانی",
    "LiquidCrystal": "پنل تخت تعاملی",
    "projector": "پروژکتور",
    "othertype": "دیگر",
    "childLock": "قفل کودک",
    "energySaving": "صرفه‌جویی در انرژی",
    "signalSourceSwitching": "منبع ورودی",
    "other": "ویژگی‌های دیگر:",
    "otherFunction": "عملکرد",
    "send": "ارسال",
    "ON": "روشن",
    "OFF": "خاموش",
    "btnAddSchedule": "بازیابی",
    "EditSchedulelist": "ویرایش برنامه زمانبندی",
    "AddSchedulelist": "افزودن برنامه زمانبندی",
    "RestoreSchedulelist": "بازیابی",
    "btn": "لغو",
    "btnNewList": "برنامه زمانبندی جدید",
    "ListName": "نام",
    "Cannotquit": "الزامی",
    "NOCannotquit": "خیر",
    "ListValidityPeriod": "دوره اعتبار",
    "ListDescription": "توضیحات",
    "currentSchedule": "لیست برنامه‌های زمانبندی",
    "historySchedule": "لیست تاریخچه",
    "selectTime": "زمان",
    "taskType": "نوع وظیفه",
    "selectBroadcasting": "پخش",
    "selectDeviveControl": "کنترل دستگاه",
    "newSchedule": "وظیفه جدید",
    "newChecklist": "چک لیست جدید",
    "titleStatus": "وضعیت",
    "titleType": "نوع",
    "titleStartTime": "زمان شروع",
    "titleEndTime": "زمان پایان",
    "titleRepeat": "تکرار",
    "titleName": "نام",
    "titleAction": "عمل",
    "tableEnabled": "فعال",
    "tablePaused": "معلق",
    "tableEdit": "ویرایش",
    "tableDelete": "حذف",
    "tableVolumeEdit": "صدای پخش",
    "tableBroadcastTitle": "عنوان",
    "tableBroadcastContent": "محتوا",
    "tableBroadcastList": "لیست",
    "tableBroadcast": "واجب",
    "btnRemoveCompletely": "حذف کامل",
    "btnEnabled": "فعال",
    "btnPaused": "معلق",
    "btnDelete": "حذف",
    "repeat0": "دوشنبه",
    "repeat1": "سه‌شنبه",
    "repeat2": "چهارشنبه",
    "repeat3": "پنج‌شنبه",
    "repeat4": "جمعه",
    "repeat5": "شنبه",
    "repeat6": "یکشنبه",
    "dialogTitleAdd": "وظیفه جدید کنترل دستگاه",
    "dialogTitleEdit": "ویرایش وظیفه کنترل دستگاه",
    "newBroadcastingSchedule": "وظیفه جدید پخش",
    "editBroadcastingSchedule": "ویرایش وظیفه پخش",
    "chooseDevice": "انتخاب دستگاه",
    "timeSetting": "تنظیم زمان",
    "controlBroadcasting": "گزینه پخش",
    "controlOption": "گزینه کنترل",
    "scheduleName": "نام وظیفه:",
    "destination": "مقصد",
    "timeTilte": "زمان",
    "repeatTitle": "تکرار",
    "dialogRepeat0": "دوشنبه",
    "dialogRepeat1": "سه‌شنبه",
    "dialogRepeat2": "چهارشنبه",
    "dialogRepeat3": "پنج‌شنبه",
    "dialogRepeat4": "جمعه",
    "dialogRepeat5": "شنبه",
    "dialogRepeat6": "یکشنبه",
    "dialogOnceType": "یکبار",
    "dialogRepeatType": "تکرار",
    "mainPower": "قدرت اصلی",
    "powerControl": "کنترل قدرت",
    "tableDisplayInputSwitch": "سوئیچ ورودی نمایشگر",
    "tableAirConditioning": "دستگاه تهویه هوا",
    "tableProjectionScreen": "پرده نمایش",
    "tableElectronicLock": "قفل برقی",
    "interactiveFlatPanel": "پنل تخت تعاملی",
    "displayInputSwitch": "سوئیچ ورودی نمایشگر",
    "speakerVolume": "صدای بلندگو",
    "MICVolume": "صدای میکروفون",
    "ProjectionScreen": "پرده نمایش",
    "ElectronicLock": "قفل برقی",
    "AirConditioning": "کولر گازی",
    "AirConditioningPower": "قدرت",
    "AirConditioningModel": "مدل",
    "AirConditioningTEMP": "دمای هوا",
    "AirConditioningFanSpeed": "سرعت فن",
    "OPEN": "باز",
    "CLOSE": "بسته",
    "UP": "بالا",
    "DOWN": "پایین",
    "PowerOFF": "خاموش",
    "PowerON": "روشن",
    "ModelAuto": "اتوماتیک",
    "ModelCool": "خنک کننده",
    "ModelHeat": "گرم کننده",
    "ModelAir": "هوا سمت",
    "TEMPLow": "کم",
    "TEMPMiddle": "متوسط",
    "TEMPHigh": "زیاد",
    "btnSave": "ذخیره",
    "btnNext": "بعدی",
    "StartTime": "زمان شروع",
    "StopTime": "زمان اتمام",
    "Mandatory": "الزامی",
    "Video": "ویدیو و صدا",
    "Notification": "اطلاع رسانی",
    "btnFile": "انتخاب فایل رسانه",
    "LastingTime": "مدت زمان",
    "textTitle": "عنوان",
    "textContent": "محتوا",
    "textTitleLetters": "کمتر از 60 کاراکتر",
    "textContentLetters": "کمتر از 320 کاراکتر",
    "CannotquitYES": "YES",
    "CannotquitNo": "No",
    "YES": "YES",
    "No": "No",
    "delTitleContent": "آیا مطمئن هستید که این برنامه زمان بندی را حذف می کنید؟",
    "delTitleListContent": "برنامه زمان بندی حذف شده به لیست تاریخ منتقل خواهد شد و قابل بازیابی است.",
    "deleListTitle": "آیا مطمئن هستید که برنامه زمان بندی را حذف می کنید؟",
    "delTitleListContent1": "حذف برنامه زمان بندی باعث پاک شدن وظایف مرتبط با آن خواهد شد، لطفاً تأیید کنید.",
    "deleListTitle1": "آیا مطمئن هستید که این برنامه زمان بندی را حذف می کنید؟",
    "delTitle": "حذف؟",
    "btnConfirm": "تأیید",
    "coxAll": "همه",
    "coxBroadcasting": "پخش",
    "coxDeviveControl": "کنترل دستگاه",
    "rdMandatory": "بله",
    "noRdMandatory": "خیر",
    "startDate": "تاریخ شروع",
    "endedDate": "تاریخ پایان",
    "or": "- ",
    "broadcastingType": "نوع",
    "ChooseTime": "زمان را انتخاب کنید",
    "ChooseDate": "تاریخ را انتخاب کنید",
    "newScheduleList": "جدول زمانی جدید",
    "editScheduleList": "ویرایش جدول زمانی",
    "listName": "نام",
    "listValidityPeriod": "دوره اعتبار",
    "listDescription": "توضیحات",
    "cancel": "لغو",
    "confirm": "تأیید",
    "save": "ذخیره",
    "addSuccess": "با موفقیت اضافه شد!",
    "addError": "افزودن ناموفق بود!",
    "editSuccess": "ویرایش با موفقیت انجام شد!",
    "editError": "ویرایش ناموفق بود!",
    "delSuccess": "حذف با موفقیت انجام شد!",
    "delError": "حذف ناموفق بود!",
    "restoreSuccess": "لیست جدول زمانی با موفقیت بازیابی شد",
    "restoreError": "بازیابی لیست جدول زمانی ناموفق بود",
    "restoreTitleContent": "این زمان با زمان جدول زمانی در لیست تداخل دارد، لطفاً دوباره انتخاب کنید",
    "Enabled": "فعال",
    "Paused": "معلق",
    "Title": "عنوان:",
    "Content": "محتوا:",
    "errorScheduleNameRequired": "نام وظیفه باید پر شود",
    "errorDeviceRequired": "لطفاً دستگاه هدف را انتخاب کنید",
    "deleTitle": "آیا مطمئن هستید که می‌خواهید این وظیفه را حذف کنید؟",
    "loopList": "لیست حلقه",
    "errorPleaseDateRange": "لطفاً یک بازه زمانی انتخاب کنید",
    "addError_2009": "نام جدول زمانی تکراری",
    "conflicts": "زمان وظیفه با موارد زیر تداخل دارد:",
    "Pleaseagain": "لطفاً دوباره وارد کنید",
    "errorScheduleName": "نام وظیفه",
    "errorListName": "نام جدول زمانی",
    "today": "امروز",
    "yesterday": "دیروز",
    "thisWeek": "این هفته",
    "lastWeek": "هفته گذشته",
    "lastMonth": "ماه گذشته",
    "thisMonth": "این ماه",
    "times": "زمان‌ها",
    "TimeConflicts": "تداخل زمانی",
    "editError_2006": "دستگاه پیدا نشد",
    "editError_2010": "نام جدول زمانی تکراری",
    "ListTimeExpired": "زمان جدول زمانی منقضی شده است، لطفاً دوباره انتخاب کنید",
    "TimeExpired": "زمان منقضی شده",
    "ControlOption": "گزینه کنترل گم شده است",
    "Pleaseleastone": "لطفاً حداقل یک گزینه کنترل انتخاب کنید",
    "Enter": "وارد شوید",
    "TitleFilled": "عنوان باید پر شود",
    "ContentFilled": "محتوا باید پر شود",
    "PleaseMediaFile": "لطفاً یک فایل رسانه‌ای انتخاب کنید",
    "PleaseSchedule": "لطفاً یک وظیفه انتخاب کنید",
    "delTitleScheduleContent": "وظیفه حذف‌شده قابل بازیابی نیست.",
    "deleTitleSchedule": "آیا مطمئن هستید که می‌خواهید این وظیفه را حذف کنید؟",
    "deleteScheduleTitle": "لطفاً وظیفه‌ای که می‌خواهید حذف کنید را انتخاب کنید",
    "PleaseFillColumn": "لطفاً نام جدول زمانی را وارد کنید",
    "PleaseDate": "لطفاً تاریخ را انتخاب کنید",
    "Previous": "قبلی",
    "RemoteControl": "کنترل از راه دور",
    "taskhasexpired": "این وظیفه منقضی شده است، لطفاً با سازنده تماس بگیرید تا زمان را به روز رسانی کند.",
    "execute": "اجرا",
    "broadcastingList": "لیست پخش",
    "volumeSuccess": "تنظیم حجم با موفقیت انجام شد",
    "volumeFailed": "تنظیم حجم با شکست مواجه شد"
  },
  "Automation": {
    "nameDuplicate": "نام وظیفه خودکار تکراری",
    "Automation": "اتوماتیک",
    "if": "اگر:",
    "ifContent": "بخش 'اگر' به شما این امکان را می‌دهد که شرایطی را بر اساس داده‌های حسگر تنظیم کنید. حسگر را انتخاب کرده و شرایطی مانند 'دما > 26°C' را مشخص کنید.",
    "then": "پس:",
    "thenContent": "بخش 'پس' به شما این امکان را می‌دهد که دستگاه‌ها را انتخاب کرده و اقداماتی برای آن‌ها تعریف کنید. دستگاه‌هایی مانند NMP1، NMP2 را انتخاب کرده و اقداماتی مانند 'روشن کردن + خنک' برای کولرها مشخص کنید.",
    "btnDelete": "حذف",
    "Add": "افزودن",
    "taskName": "نام وظیفه",
    "dialogTaskName": "نام وظیفه:",
    "Statue": "وضعیت",
    "DevicesApplied": "دستگاه‌های اعمال شده",
    "Operation": "عملیات",
    "AirConditioningPower": "قدرت",
    "AirConditioningModel": "مدل",
    "AirConditioningFanSpeed": "سرعت فن",
    "bold": "چرخش",
    "selectTask": "لطفاً وظیفه را انتخاب کنید",
    "autoTaskAdd": "افزودن وظیفه اتوماتیک",
    "autoTaskEdit": "ویرایش وظیفه اتوماتیک",
    "Destination": "مقصد",
    "selectConditions": "لطفاً عملی را که می‌خواهید انجام دهید مشخص کنید.",
    "selectDestination": "لطفاً دستگاه‌های NMP هدف را انتخاب کنید، سپس عملی را که می‌خواهید انجام دهید مشخص کنید.",
    "AirConditioningTEMP": "دما",
    "AirConditioningHumidness": "رطوبت",
    "noData": "هیچ وظیفه‌ای اضافه نشده است. برای افزودن وظایف روی دکمه \"افزودن\" کلیک کنید."
  },
  "rs232Translation": {
    "reliveBinding": "قطع اتصال",
    "RELIVEBINDING": "قطع اتصال",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "نام CBX نمی‌تواند خالی باشد",
    "BrandNoNull": "برند نمی‌تواند خالی باشد",
    "ModelNoNull": "مدل نمی‌تواند خالی باشد",
    "AcNoNull": "کنترل تهویه مطبوع نمی‌تواند خالی باشد",
    "RcNoNull": "کنترل از راه دور نمی‌تواند خالی باشد"
  },
  "route": {
    customize: 'سفارشی‌سازی',
    "InputSourcesLinkage": "لینک منابع ورودی",
    "Automation": "اتوماتیک",
    "dashboard": "Dashboard",
    "i18n": "I18n",
    "organizationMge": "گروه‌ها",
    "userMge": "کاربران",
    "authorityMge": "مجوزها",
    "roleMge": "نقش‌ها",
    "equipmentMge": "دستگاه‌ها",
    "workstationMge": "سرور رسانه",
    "cloudDiskMge": "مدیریت ذخیره‌سازی",
    "operationLog": "گزارش عملیات",
    "setting": "تنظیمات",
    "resourceMge": "مدیریت منابع",
    "storageMge": "مدیریت ذخیره‌سازی",
    "interfaceRename": "تغییر نام رابط",
    "processorManager": "مدیر پردازنده",
    "projectorCode": "مدیریت کد سریال",
    "projectorCodeSetting": "تنظیمات کد سریال",
    "RepairLog": "گزارش تعمیرات",
    "remoteControl": "کد کنترل از راه دور",
    "acCode": "کد کنترل تهویه مطبوع",
    "cardMge": "کارت‌ها",
    "cardLog": "گزارش استفاده از کارت",
    "cardManager": "مدیر کارت",
    "meetingManager": "جلسه",
    "meetingRoomManager": "مدیریت اتاق",
    "meetingDoorManager": "مدیریت پنل"
  },
  "navbar": {
    "logOut": "خروج از حساب",
    "dashboard": "داشبورد",
    "screenfull": "تمام صفحه",
    "language": "زبان",
    "userConsole": "کنسول Q-NEX",
    "BackTianwa": "بازگشت به Tianwa"
  },
  "feedback": {
    "Feedback": "بازخورد",
    "email": "لطفاً ایمیل خود را برای بازخورد ما وارد کنید.",
    "content": "به خوشامدگویی و ارسال پیام‌های شما برای بهبود محصولات ما. از نظرات شما متشکریم.",
    "submit": "ارسال",
    "emailNoEmpty": "ایمیل نمی‌تواند خالی باشد",
    "emailTrueRule": "لطفاً فرمت صحیح ایمیل را وارد کنید",
    "contentNoEmpty": "محتوا نمی‌تواند خالی باشد",
    "feedbackSuccess": "بازخورد با موفقیت ارسال شد",
    "feedbackFailed": "بازخورد ارسال نشد",
    "emailNoChinese": "پست الکترونیک نمی‌تواند حاوی کاراکترهای چینی باشد",
    "emailLength": "بین 5 تا 100 کاراکتر طول داشته باشد",
    "GroupNameLength": "بین 1 تا 20 کاراکتر طول داشته باشد",
    "emailSpecialString": "این جعبه ورودی نمی‌تواند شامل رشته‌های خاص باشد"
  },
  "login": {
    "title": "خوش آمدید",
    "logIn": "ورود به سیستم",
    "username": "نام کاربری",
    "password": "کلمه عبور",
    "any": "هر",
    "thirdparty": "یا با استفاده از",
    "thirdpartyTips": "در محیط محلی قابل شبیه‌سازی نیست، لطفاً شبیه‌سازی کسب‌وکار خود را ترکیب کنید!",
    "placeholder": "[\n  \"نام کاربری\",\n  \"کلمه عبور\",\n  \"کد تأیید\"\n]",
    "userNameTitle": "نام کاربری اشتباه است!",
    "forget": "فراموش کرده‌اید؟",
    "loginTitle0": "ورود با موفقیت انجام شد!",
    "loginTitle1000": "نام کاربری یا کلمه عبور اشتباه است!",
    "loginTitle1001": "نام کاربری و کلمه عبور باید پر شوند!",
    "loginTitle1002": "کد تأیید باید پر شود!",
    "loginTitle1003": "وضعیت کاربر غیرقانونی است، ورود ناموفق!",
    "loginTitle1004": "خطای کد تأیید!",
    "loginTitle1005": "وارد نشده‌اید، لطفاً ابتدا وارد شوید!",
    "loginTitleUserName": "نام کاربری باید پر شود!",
    "loginTitlePwd": "کلمه عبور باید پر شود!",
    "loginTitleVercode": "کد تأیید باید پر شود!",
    "errorLogin": "حقوق کاربری کافی نیست، امکان ورود وجود ندارد!",
    "titleLoginNameFormat": "باید از کاراکترها یا کاراکترها و اعداد تشکیل شده باشد."
  },
  "organizationMge": {
    "CanTDragTop": "نمی توان به ریشه منتقل شد",
    "prefixCannotBeEmpty": "پیشوند حساب ادمین سطح بالا نمی تواند خالی باشد",
    "enterEnglishLetters": "پیشوند حساب ادمین سطح بالا فقط می تواند شامل حروف انگلیسی و اعداد باشد",
    "dateNotSelected": "تاریخ شروع دوره اعتبار سرویس استریم انتخاب نشده است",
    "btnAddChild": "افزودن زیرمجموعه",
    "btnAddSibling": "افزودن هم‌رده",
    "title": "راهنما:",
    "againTitle": "لطفاً دوباره تایید کنید:",
    "sort": "مرتب‌سازی:",
    "realName": "نام واقعی:",
    "titleShooleRq": "این فیلد باید پر شود",
    "titleShooleNub": "کمتر از 100 حرف",
    "schoolName": "نام گروه:",
    "type": "نوع گروه:",
    "accountPrefix": "حساب کاربری مدیر:",
    "organization": "موزع",
    "terminalMechanism": "کاربر نهایی",
    "equipmentNum": "شماره دستگاه:",
    "organizationNum": "تعداد گروه‌های ترمینال:",
    "adminName": "حساب کاربری مدیر:",
    "adminPwd": "کلمه عبور مدیر:",
    "edit": "ویرایش",
    "add": "افزودن",
    "del": "حذف",
    "addSuccess": "افزوده شد با موفقیت",
    "addError": "افزودن ناموفق!",
    "editSuccess": "ویرایش با موفقیت انجام شد",
    "editError": "ویرایش ناموفق!",
    "delSuccess": "حذف با موفقیت انجام شد!",
    "delWarn": "این گروه با دستگاه‌های متصل نمی‌تواند حذف شود",
    "delError": "حذف ناموفق!",
    "cancel": "لغو",
    "confirm": "تایید",
    "save": "ذخیره",
    "TrialWorkstation": "شما در حال حاضر در وضعیت آزمایشی هستید که فقط می‌توانید حداکثر به 3 دستگاه ترمینال پخش و استریم زنده ارسال کنید.",
    "Normal": "عادی",
    "NormalWorkstation": "دوره اعتبار سرویس استریم شما از ",
    "to": "تا",
    "Advent": "آغاز",
    "AdventWorkstationOne": "سرویس استریم شما در تاریخ ",
    "AdventWorkstationTwo": "منقضی خواهد شد، لطفاً برای تمدید به موقع با نماینده خود تماس بگیرید.",
    "Expired": "منقضی شده",
    "ExpiredWorkstation": "سرویس استریم شما منقضی شده است، لطفاً برای تمدید به موقع با نماینده خود تماس بگیرید.",
    "admin": "مدیر:",
    "serviceState": "سرویس رسانه استریم:",
    "serviceStateLIST": "سرویس رسانه استریم",
    "ValidityPeriod": "دوره اعتبار:",
    "ValidityPeriodLIST": "دوره اعتبار",
    "Trial": "آزمایشی",
    "Permanent": "دائمی",
    "AnnualBilling": "صورتحساب سالانه",
    "mediaValidityPeriod": "دوره اعتبار:",
    "mediaValidityPeriodLIST": "دوره اعتبار",
    "contactInformation": "جزئیات تماس (برای اطلاع رسانی تمدید سرویس رسانه استریم)",
    "company": "نام شرکت:",
    "email": "ایمیل:",
    "phone": "تلفن:",
    "StartDate": "تاریخ شروع",
    "EndDate": "تاریخ پایان",
    "To": "تا",
    "TerminalName": "نام کاربر نهایی",
    "Competence": "مدیر",
    "operate": "عملیات",
    "statusFilter": "فیلتر وضعیت",
    "disableStreaming": "آیا مطمئن هستید که می‌خواهید سرویس استریم را غیرفعال کنید؟",
    "enableStreaming": "آیا مطمئن هستید که می‌خواهید سرویس استریم را فعال کنید؟",
    "disableStreamingContent": "وقتی سرویس استریم غیرفعال می‌شود، گروه قادر به استفاده از قابلیت‌های مربوط به پخش و پخش زنده نخواهد بود.",
    "enableStreamingContent": "لطفاً برای گروه‌های با سرویس استریم منقضی شده، دوره اعتبار را اصلاح کنید.",
    "search": "نام سازمان را وارد کنید",
    "optionsYearZero": "لطفاً انتخاب کنید",
    "optionsYearOne": "یک سال",
    "optionsYearTwo": "دو سال",
    "optionsYearThree": "سه سال",
    "dialogName": "نام:",
    "detTitle": "حذف گروه باعث می‌شود که تمام محتوای زیر آن نیز حذف شود.",
    "groupDelTitle": "آیا مطمئن هستید که می‌خواهید این گروه را حذف کنید؟",
    "delTitle": "حذف؟",
    "delTitleContent": "محتوای انتخابی از پایگاه داده حذف خواهد شد. این عملیات قابل بازگشت نیست. آیا مطمئن هستید که می‌خواهید ادامه دهید؟",
    "delCancelButton": "لغو",
    "delConfirmButton": "تأیید",
    "copySuccess": "محتوا در کلیپ‌بورد کپی شد.",
    "copyError": "مرورگر از کپی خودکار پشتیبانی نمی‌کند",
    "error1200": "نام گروه تکراری",
    "error1201": "تکرار گروه یا شناسه گروه",
    "error1202": "تعداد دستگاه‌های قابل اتصال از حد مجاز تجاوز کرده است",
    "error1203": "نام کاربری تکراری",
    "error1204": "گروهی با همان نام در همان سطح وجود دارد",
    "error1210": "لطفاً رمز عبور مدیر را وارد کنید",
    "warningGroup": "یک گروه انتخاب کنید!",
    "warningTerminal": "گروه پایانه نمی‌تواند زیرگروه بسازد!",
    "account": "حساب تکراری",
    "titleOrganization": "توجه: پیشوند حساب در سطح سازمان تعریف می‌شود. تمام حساب‌های کاربری در این سازمان از یک پیشوند مشترک استفاده خواهند کرد.",
    "all": "همه"
  },
  "userMge": {
    "nickName": "نام مستعار",
    "contentWithBrand": "نام برند یا مدل را وارد کنید",
    "contentwithIp": "جستجو با نام دستگاه یا آدرس IP.",
    "btnAdd": "کاربر جدید",
    "btnDelete": "حذف",
    "btnDownload": "دانلود قالب",
    "btnImport": "واردات دسته جمعی",
    "btnExport": "دانلود",
    "btnDisable": "غیرفعال کردن",
    "btnEnable": "فعال کردن",
    "accountType": "فیلتر بر اساس نقش",
    "organizationName": "فیلتر بر اساس گروه",
    "content": "جستجو",
    "systemAccount": "شناسه کاربر",
    "idCardNumber": "شناسه کارمندی",
    "customizeAccount": "حساب شخصی سازی شده",
    "userName": "نام",
    "licenseNum": "شماره مجوز",
    "phone": "تلفن",
    "email": "ایمیل",
    "role": "نقش",
    "status": "وضعیت",
    "affiliatedOrganization": "گروه‌ها",
    "roleTypeList1": "کاربر عمومی",
    "roleTypeList2": "دانش‌آموز",
    "roleTypeList3": "والدین",
    "roleTypeList101": "مدیر عامل",
    "roleTypeList102": "مدیر",
    "roleTypeList301": "مدیر ارشد",
    "userStatus1": "فعال",
    "userStatus2": "مسدود شده",
    "userStatus3": "حذف",
    "operate": "عملیات",
    "dialogName": "نام مستعار:",
    "dialogUserName": "شناسه کاربر:",
    "dialogUserNameDefined": "نام کاربری:",
    "dialogPassword": "رمز عبور:",
    "dialogID": "شناسه کارمندی:",
    "dialogRole": "نقش:",
    "dialogEmail": "ایمیل:",
    "dialogPhone": "تلفن:",
    "dialogGroup": "گروه:",
    "addUser": "کاربر جدید",
    "editUser": "ویرایش کاربر",
    "addSuccess": "اضافه شدن با موفقیت!",
    "addError": "اضافه نشد!",
    "editSuccess": "ویرایش با موفقیت!",
    "editError": "ویرایش نشد!",
    "delSuccess": "حذف با موفقیت!",
    "delError": "حذف نشد!",
    "cancel": "لغو",
    "confirm": "تأیید",
    "save": "ذخیره",
    "tableDel": "حذف",
    "tableEdit": "ویرایش",
    "selectRoles": "انتخاب نقش‌ها",
    "delTitle": "حذف؟",
    "delTitleContent": "محتوای انتخابی از پایگاه داده حذف خواهد شد. این عملیات قابل بازگشت نیست. آیا مطمئن هستید که می‌خواهید ادامه دهید؟",
    "delCancelButton": "لغو",
    "delConfirmButton": "تأیید",
    "titleRealNameRq": "این فیلد باید پر شود",
    "titleRealNameFormat": "نام کاربری را انتخاب کنید که فقط شامل حروف و اعداد باشد.",
    checkPasswordTitleTwo: 'لطفاً یک رمز عبور حداقل ۶ کاراکتری شامل حروف و اعداد تنظیم کنید. استفاده از کاراکترهای خاص مجاز است (بدون محدودیت).',
    checkPasswordTitle: 'رمز عبور باید حداقل ۶ کاراکتر داشته باشد و نمی‌تواند فقط شامل اعداد باشد',
    "titlePhoneFormat": "تلفن فقط می‌تواند شامل اعداد، () + و - باشد.",
    "phoneFilled": "تلفن باید پر شود.",
    "titleEmaileFormat": "فرمت ایمیل اشتباه است.",
    "emaileFilled": "ایمیل باید پر شود.",
    "titlUserNameDefinedNub": "نام کاربری نباید بیش از ۳۰ کاراکتر باشد",
    "titlRealNameNub": "نام نباید بیش از ۳۰ کاراکتر باشد.",
    "titlRealNameField": "نام باید پر شود.",
    "thisPasswordField": "رمز عبور باید پر شود.",
    "titlPassWordNub": "رمز عبور باید بین ۶ تا ۳۰ کاراکتر باشد.",
    "enableStatus": "فعال کردن کاربر",
    "stopStatus": "غیرفعال کردن کاربر",
    "enableContent": "آیا مطمئن هستید که می‌خواهید کاربر(ها) را فعال کنید؟",
    "stopContent": "آیا مطمئن هستید که می‌خواهید کاربر(ها) را غیرفعال کنید؟",
    "error1400": "نام کاربری از قبل وجود دارد، لطفاً دوباره تلاش کنید",
    "error1401": "شناسه کاربری از قبل وجود دارد و عملیات ناموفق بود!",
    "error1402": "گروه وجود ندارد، واردات ناموفق بود!",
    "error1403": "داده‌ها اشتباه است",
    "error1404": "دسترسی ناکافی",
    "selUser": "لطفاً یک کاربر را انتخاب کنید!",
    "error1405": "دریافت نقش ناموفق بود",
    "error1406": "فرمت داده‌های اطلاعات وارد شده کاربر اشتباه است",
    "error1407": "ایمیل از قبل وجود دارد و عملیات ناموفق بود.",
    "error1408": "تلفن از قبل وجود دارد و عملیات ناموفق بود.",
    "error1900": "پارامتر دسترسی خالی است",
    "error1610": "لطفاً از نقش مدیر ترمینال برای انجام عملیات‌های مربوطه استفاده کنید",
    "errorOrgIdList": "گروه نمی‌تواند خالی باشد!",
    "Bindsucceeded": "اتصال موفقیت‌آمیز",
    "Bindfailed": "اتصال ناموفق",
    "tableuserName": "نام کاربری",
    "titleDevice": "دستگاه",
    "bindDevice": "دستگاه به هم پیوسته",
    "Bindcontrollable": "آیا اکنون دستگاه قابل کنترل را متصل کنید؟"
  },
  "devicesMge": {
    mustChooseOne: 'هنگام انتخاب کنترل از راه دور هوشمند، باید حداقل یک دستور کنترل انتخاب شود',
    customName: 'نام سفارشی',
    "testAcCode": "تست کد کنترل A/C جدید",
    "Online": "آنلاین",
    "Offline": "آفلاین",
    "unBindConfirm": "آیا مطمئن هستید که می‌خواهید Serial را قطع کنید؟",
    "unBindConfirm485": "آیا مطمئن هستید که می‌خواهید RS485 را قطع کنید؟",
    "notYetBoundRS232": "دستگاه هنوز به کد Serial متصل نیست. می‌توانید به دستگاه > کد کنترل Serial بروید و آن را اضافه کنید.",
    "RsFollowingFunctions": "با استفاده از کدهای Serial می‌توانید عملکردهای زیر را انجام دهید:",
    "Unbind": "قطع اتصال",
    "Limit255": "نام فایل می‌تواند حداکثر ۲۵۵ کاراکتر باشد",
    "clear": "پاک کردن",
    "equipName": "نام دستگاه",
    "equipType": "نوع",
    "selectField": "لطفاً فایل را انتخاب کنید",
    "dialogTip": "*اگر جعبه ورودی سمت راست خالی است، محتوای سمت چپ به طور پیش‌فرض نمایش داده می‌شود",
    "dialogTipSingle": "*اگر یک دستگاه نامگذاری نشده باشد، از نام \"همه\" استفاده می‌شود",
    "cantDelTemplateOne": "CBX دستگاه ",
    cantDelTemplateTwo: 'CBX دستگاه "{deviceName}" یک قالب است. آیا مطمئن هستید که می‌خواهید آن را حذف کنید؟',
    "templateTitle": "جایگزینی الگو",
    "templateContentOne": "نام دستگاه \" ",
    "templateContentTwo": " به عنوان الگوی مشترک CBX تنظیم شده است. آیا مطمئن هستید که دستگاه فعلی را به عنوان الگو تنظیم می‌کنید؟",
    "vcbNoTemplateNoSave": "امکان ذخیره‌سازی بدون الگو وجود ندارد",
    "vcbAcControl": "یک دستگاه تهویه انتخاب کنید",
    "vcbRemoteControl": "یک دستگاه کنترل از راه دور انتخاب کنید",
    "vcbPOWERControl": "کنترل توان",
    "vcbRS232Control": "کنترل Serial",
    "vcbIRControl": "کنترل IR",
    "vcbSetting": "تنظیمات CBX",
    "editVcb": "ویرایش CBX",
    "vcbName": "نام CBX",
    "iot": "کنترل CBX",
    "saveAsTemplate": "ذخیره به عنوان الگو",
    saveAsTemplatereplenish: 'چند دستگاه را برای استفاده از این قالب در مرکز کنترل انتخاب کنید',
    "Upload": "بارگذاری",
    "Select": "انتخاب",
    "InputDeviceID": "شناسه دستگاه را وارد کنید",
    "editNameTips": "* اگر کادر ورودی در سمت راست خالی باشد، محتویات سمت چپ به طور پیش‌فرض نمایش داده می‌شود.",
    "_RS232A": "اینترفیس اول",
    "_RS232B": "اینترفیس دوم",
    "institutionDirectory": "دایرکتوری مؤسسه",
    "projectionScreenLinkageSetting": "تنظیمات کنترل صفحه نمایش پروژکتور",
    "screenLiftingLinkageDisplaySwitch": "کنترل ارتباط صفحه نمایش پروژکتور و نمایشگر:",
    "stopLinkage": "غیرفعال (کنترل صفحه نمایش پروژکتور جداگانه)",
    "Enable": "فعال (کنترل همزمان صفحه نمایش پروژکتور و نمایشگر)",
    "btnAddDevice": "افزودن دستگاه",
    "btnImportDevice": "واردات دسته‌جمعی دستگاه",
    "btnDel": "حذف",
    "btnEdit": "ویرایش",
    "tableIpAddress": "آدرس IP",
    "MACAddress": "آدرس MAC",
    "firmwareVersion": "نسخه فریمور",
    "NA": "ناموجود",
    "tableDeviceName": "نام دستگاه",
    "tableStatus": "وضعیت",
    "tableVideoSwitch": "سوئیچ ویدئو",
    "tableAudio": "توزیع A/V",
    "tablePowerControl": "کنترل برق",
    "tableRS232": "کنترل سریال",
    "tableIR": "کنترل IR",
    "tableRFIDCard": "کارت IC",
    "tableControlPanel": "پنل کنترل",
    "tableOrganization": "گروه‌ها",
    "tableActions": "اقدامات",
    "dialogAddTitle": "افزودن دستگاه",
    "dialogEditTitle": "ویرایش دستگاه",
    "dialogBatchAddTitle": "افزودن دسته‌جمعی دستگاه",
    "dialogBatchEditTitle": "ویرایش دسته‌جمعی دستگاه",
    "btnCancel": "لغو",
    "Devices": "دستگاه‌ها:",
    "ProjectorCode": "کد Serial:",
    "Group": "گروه:",
    "btnBatchAdd": "افزودن دسته‌جمعی",
    "delTitle": "حذف؟",
    "delTitleContent": "محتویات انتخابی از پایگاه داده حذف خواهند شد. این فرآیند غیرقابل بازگشت است. آیا مطمئن هستید که می‌خواهید ادامه دهید؟",
    "delCancelButton": "لغو",
    "delConfirmButton": "تأیید",
    "addError": "افزودن ناموفق!",
    "editSuccess": "ویرایش موفقیت‌آمیز!",
    "editError": "ویرایش ناموفق!",
    "delSuccess": "حذف موفقیت‌آمیز!",
    "delError": "حذف ناموفق!",
    "content": "جستجو",
    "cancel": "لغو",
    "confirm": "تأیید",
    "save": "ذخیره",
    "tableDel": "حذف",
    "tableEdit": "ویرایش",
    "selectRoles": "انتخاب نقش‌ها",
    "selectType": "لطفاً یک نوع انتخاب کنید",
    "selectDevices": "لطفاً دستگاهی انتخاب کنید",
    "titleRealNameRq": "این فیلد باید پر شود",
    "titleRealNameNub": "کمتر از 100 کاراکتر",
    "titlPassWordNub": "کمتر از 15 کاراکتر",
    "error1900": "پارامتر دسترسی داده‌شده خالی است",
    "error2000": "تعداد دستگاه‌های قابل اتصال بیشتر از حد مجاز است",
    "error2001": "کد دستگاه وارد شده نادرست است یا هنوز وارد سیستم نشده است",
    "error2002": "نام دستگاه تکراری وارد شده است",
    "error2003": "شناسه دستگاه وارد شده استفاده شده است",
    "error2004": "خطای داده وارد شده",
    "error2005": "نام برند یا مدل با داده‌های موجود در سیستم تکراری است؛ لطفاً نام برند یا مدل را تغییر دهید.",
    "error2008": "این دستگاه قبلاً با گروه دیگری مرتبط است",
    "notDevicesName": "نام دستگاه نمی‌تواند خالی باشد",
    "notDevicesNO": "شناسه دستگاه نمی‌تواند خالی باشد",
    "dialogDevicesName": "نام دستگاه:",
    "dialogDevicesID": "شناسه دستگاه:",
    "dialogProjectorCode": "کد Serial:",
    "dialogGroup": "گروه:",
    "dialogSel": "لطفاً انتخاب کنید",
    "errorOrgIdList": "گروه نمی‌تواند خالی باشد!",
    "errorDevicesName": "نام دستگاه نمی‌تواند خالی باشد!",
    "errorDevicesNo": "شناسه دستگاه نمی‌تواند خالی باشد!",
    "dialogTiltleDevices": "دستگاه‌ها:",
    "uploadSuccess": "بارگذاری موفقیت‌آمیز",
    "addSuccess": "افزودن موفقیت‌آمیز",
    "ChooseGroups": "انتخاب گروه‌ها",
    "ChooseIcon": "انتخاب آیکون",
    "dialogDevicesTitle": "تنظیمات پارامتر برای دستگاه‌های زیر اعمال می‌شود",
    "backDevice": "بازگشت",
    "bootSetting": "تنظیمات راه‌اندازی",
    "nmpOpenSetting": "تنظیمات روشن شدن",
    "npsOpenSetting": "تنظیمات روشن شدن",
    "nmpPowerSettings": "تنظیمات مدیریت مصرف برق",
    "npsPowerSettings": "تنظیمات مدیریت مصرف برق",
    "nmpInterfaceSettings": "تنظیمات رابط",
    "npsInterfaceSettings": "تنظیمات رابط",
    "nmpDefaultChannel": "تنظیمات کانال پیش‌فرض",
    "nmpCloseSetting": "تنظیمات خاموش شدن",
    "npsCloseSetting": "تنظیمات خاموش شدن",
    "SwipeToStart": "فعال کردن قفل (کارت را لمس کنید تا باز شود)",
    "ControlPanelToStart": "غیرفعال کردن قفل (عملیات نامحدود)",
    "Display": "نمایش",
    "External": "خارجی",
    "startingUpMethod": "فعال/غیرفعال کردن قفل پنل:",
    "startWith": "شروع با:",
    "nmpstartWith": "روشن شدن همزمان:",
    "nmpcloseWith": "خاموش شدن همزمان:",
    "RS232Tip": "زمانی که برق اصلی خاموش است، مجموعاً ۵ رابط Serial، از جمله Serial و حداکثر ۴ CBX، دستور خاموشی مربوطه را دریافت خواهند کرد.",

    startPowerTip: 'هنگام روشن شدن، همه دستگاه‌های متصل به رابط‌های برق CBX به صورت همزمان روشن می‌شوند.',
    startAirTip: 'هنگام روشن شدن، همه کولرهای گازی متصل از طریق مادون قرمز دستگاه/CBX به صورت یکپارچه روشن می‌شوند.',
    startIrTip: 'هنگام روشن شدن، فرمان هماهنگی از طریق مادون قرمز دستگاه/CBX ارسال می‌شود (مثلاً پایین آمدن پرده، روشن شدن ویدئو پروژکتور).',
    startRSTip: 'هنگام روشن شدن، فرمان روشن شدن از طریق رابط Serial دستگاه/CBX ارسال می‌شود.',
    CloseDisplayTip: 'دستگاه‌های متصل به رابط DISPLAY هنگام خاموش شدن NDP/NMP به طور خودکار خاموش می‌شوند. این تنظیم توسط سیستم‌عامل دستگاه کنترل شده و قابل تغییر از طریق نرم‌افزار نیست.',
    CloseExternalTip: 'دستگاه‌های متصل به رابط EXTERNAL هنگام خاموش شدن NDP/NMP به طور خودکار خاموش می‌شوند. این تنظیم توسط سیستم‌عامل دستگاه کنترل شده و قابل تغییر از طریق نرم‌افزار نیست.',
    ClosePowerTip: 'هنگام خاموش شدن، همه دستگاه‌های متصل به رابط‌های برق CBX به صورت همزمان خاموش می‌شوند.',
    CloseAirTip: 'هنگام خاموش شدن، همه کولرهای گازی متصل از طریق مادون قرمز دستگاه/CBX به صورت یکپارچه خاموش می‌شوند.',
    CloseIrTip: 'هنگام خاموش شدن، فرمان هماهنگی از طریق مادون قرمز دستگاه/CBX ارسال می‌شود (مثلاً بالا رفتن پرده، خاموش شدن ویدئو پروژکتور).',
    CloseRSTip: 'هنگام خاموش شدن، فرمان خاموش شدن از طریق رابط Serial دستگاه/CBX ارسال می‌شود.',
    npsOpenRS232Tip: 'وقتی منبع برق اصلی روشن شود، 2 پورت سریال NPS کدهای دستور روشن شدن مربوطه را دریافت خواهند کرد.',
    "npsRS232Tip": "زمانی که برق اصلی خاموش است، دو رابط Serial NPS دستور خاموشی مربوطه را دریافت خواهند کرد.",
    "useCardTip": "پس از باز کردن قفل کارت، برق دستگاه‌ها به طور خودکار فعال می‌شود.",
    "npsCardTip": "پس از باز کردن قفل کارت، برق اصلی دستگاه‌ها به طور خودکار فعال می‌شود.",
    "PowerOutageHandling": "مدیریت قطعی برق",
    "PowerOutageHandTip": "برای دسترسی مداوم در هنگام قطعی برق غیرمنتظره، گزینه 'باز کردن قفل در قطعی برق' را انتخاب کنید. در غیر این صورت، گزینه 'قفل در قطعی برق' را انتخاب کنید تا دسترسی محدود شود.",
    "acSetting": "تنظیمات A/C",
    "ChooseType": "نوع دستگاه",
    "ChooseBrand": "یک برند انتخاب کنید",
    "ChooseModel": "یک مدل انتخاب کنید",
    "btnConnectingTest": "تست اتصال",
    "LockSetting": "تنظیمات قفل الکتریکی",
    "ElectricLockType": "نوع قفل الکتریکی:",
    "PowerUNLOCK": "باز کردن قفل در قطعی برق",
    "PowerLOCK": "قفل در قطعی برق",
    "none": "هیچکدام",
    "oddParity": "پاریتۀ فردی",
    "EvenParity": "پاریتۀ زوجی",
    "LastSetting": "آخرین تنظیم",
    "ElectricLockClosing": "بستن قفل الکتریکی:",
    "manualSwitch": "سوئیچ دستی",
    "Auto": "خودکار (در ",
    "projectorSetting": "انتخاب دستگاه و اتصال",
    "baudRate": "سرعت Baud",
    "Parity": "پاریتاژ",
    "ON": "روشن شدن",
    "OFF": "خاموش شدن",
    "Channel1": "کانال 1",
    "Channel2": "کانال 2",
    "PowerOffDelay": "تاخیر خاموش شدن",
    "second": "ثانیه",
    "DefaultChannel": "کانال پیش‌فرض",
    "HDMIA": "خروجی HDMI A:",
    "HDMIB": "خروجی HDMI B:",
    "HDMIC": "خروجی HDMI C:",
    "btnSaveApply": "ذخیره و اعمال به...",
    "btnSave": "ذخیره",
    "btnCustomize": "سفارشی",
    "ACIsPowerTitle": "لطفاً بررسی کنید که آیا دستگاه تهویه مطبوع روشن است؟",
    "ACIsPowerContent": "لطفاً قبل از آزمایش دستگاه تهویه مطبوع را خاموش کنید. اگر به درستی روشن نشد، لطفاً اطمینان حاصل کنید که برند و مدل دستگاه تهویه مطبوع درست است.",
    "btnNextModel": "نه، مدل بعدی را آزمایش کنید",
    "btnYes": "بله",
    "errorConnecting": "آزمایش اتصال شکست خورد",
    "hot": "داغ",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "تنظیمات کنترل IR",
    "acControlTitle": "یک دستگاه تهویه مطبوع انتخاب کنید:",
    "acControlTitleNew": "دستگاه تهویه مطبوع",
    "intelligentControlTitle": "یک دستگاه کنترل از راه دور انتخاب کنید:",
    "intelligentControlTitleNew": "دستگاه کنترل از راه دور",
    "btnACControlCode": "شناسایی کد کنترل جدید A/C",
    "btnAddRemoteControl": "کد کنترل از راه دور جدید",
    "ACControlCodeTitle": "شناسایی کد کنترل A/C",
    "ACControlCodeseft1": "شناسایی کد",
    "ACControlCodeseft2": "اضافه کردن اطلاعات",
    "btnStartIdentify": "شروع",
    "Identifysuccess": "شناسایی با موفقیت!",
    "BeingIdentify": "در حال تجزیه و تحلیل...",
    "acBrand": "برند دستگاه تهویه مطبوع",
    "acModel": "مدل دستگاه تهویه مطبوع",
    "IdentifyFailureTitle": "یافتن کد موفق نشد",
    "IdentifyFailureContent": "شناسایی ناموفق بود، این مدل در حال حاضر پشتیبانی نمی‌شود. لطفاً ریموت کنترل را امتحان کنید",
    "btnTryAgain": "دوباره امتحان کنید",
    "btnJump": "برو به ریموت کنترل",
    "ACrideo": "دستگاه تهویه مطبوع",
    "ortherRideo": "دستگاه‌های دیگر",
    "btnBack": "بازگشت",
    "btnSortOut": "برای ویرایش بروید",
    "remoteControlSeft1": "نوع دستگاه را انتخاب کنید",
    "remoteControlSeft2": "یادگیری کد",
    "remoteControlSeft3": "اضافه کردن اطلاعات",
    "addRemoteControlError": "متاسفانه نمی‌توان کدهای بیشتری یاد گرفت. لطفاً ابتدا کدهای موجود ریموت کنترل را ویرایش کنید",
    "btnPrevious": "قبلی",
    "btnNextStep": "بعدی",
    "remoteControlErrorTitle": "یادگیری کد موفق نبود",
    "remoteControlErrorContent1": "1. فرستنده مادون قرمز مسدود نشده است",
    "remoteControlErrorContent2": "2. هیچ مزاحمت نوری قوی در اطراف گیرنده وجود ندارد",
    "remoteControlErrorContent3": "3. فرستنده مادون قرمز به درستی نصب شده است",
    "remoteControlErrorContent4": "4. ریموت کنترل به خوبی کار می‌کند",
    "deviceItem1": "دستگاه تهویه مطبوع",
    "deviceItem2": "پروژکتور",
    "deviceItem3": "تلویزیون",
    "deviceItem4": "پنکه",
    "deviceItem5": "چراغ",
    "deviceItem6": "سایر",
    "deviceItem7": "پنل تخت تعاملی",
    "deviceItem8": "سیستم ضبط سخنرانی",
    "deviceItem9": "دوربین PTZ",
    "RS232protocol": "پروتکل Serial:",
    "btnRemoteControl": "شروع به یادگیری",
    "BeingIdentify1": "در حال تجزیه و تحلیل...",
    "Identifysuccess1": "موفقیت",
    "controllerType1": "دستگاه تهویه مطبوع",
    "controllerType2": "Serial",
    "controllerType3": "تلویزیون",
    "controllerType4": "پنکه",
    "controllerType5": "چراغ",
    "controllerType9": "سایر",
    "rqRemoteControlCode": "لطفاً نام کد کنترل از راه دور را وارد کنید",
    "rqBrand": "لطفاً برند دستگاه تهویه مطبوع را وارد کنید",
    "rqModel": "لطفاً مدل دستگاه تهویه مطبوع را وارد کنید",
    "error2016": "نام کنترل از راه دور تکراری است، لطفاً یک نام دیگر وارد کنید",
    "RS232Setting": "تنظیمات کد سریال",
    "IR232Setting": "تنظیمات IR",
    "SystemError": "خطای سیستم. لطفاً دوباره تلاش کنید",
    "conditionerCodeContent": "کد دستگاه تهویه مطبوع پیدا نشد، لطفاً دوباره تلاش کنید",
    "remoteControlCodeContent": "کد کنترل از راه دور پیدا نشد، لطفاً دوباره تلاش کنید",
    "btnRetry": "دوباره تلاش کنید",
    "Bindusers": "کاربر را متصل کنید",
    "tablebinduser": "کاربران را متصل کنید",
    "Refresh": "بارگذاری مجدد",
    "Binduserlable": "آیا کاربران را که اکنون می‌توانند دستگاه را کنترل کنند متصل کنید؟",
    "SaveApplySuccessfully": "ذخیره و اعمال با موفقیت",
    "DeviceType": "نوع:",
    "tableDeviceType": "نوع",
    "empty": "خالی است.",
    "sendCommand": "ارسال بعداً",
    "enable": "فعال",
    "disable": "غیرفعال",
    "SYNCremoteControl": "همگام‌سازی با کنترل از راه دور",
    "analysisfailed": "تحلیل شکست خورد، لطفاً دوباره تلاش کنید!",

    "CBX": {
      "powerSupplyON": "روشن کردن",
      "powerSupplyOFF": "خاموش کردن",
      "powerVcrON": "شروع ضبط",
      "powerVcrOFF": "متوقف کردن ضبط",
      "lockScreenON": "قفل روشن",
      "lockScreenOFF": "قفل خاموش",
      "childLockON": "قفل کودک روشن",
      "childLockOFF": "قفل کودک خاموش",
      "energySavingON": "حالت صرفه‌جویی در مصرف انرژی روشن",
      "energySaving": "صرفه‌جویی در مصرف انرژی",
      "energySavingOFF": "صرفه‌جویی در مصرف انرژی خاموش",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "اندروید",
      "volumeAdjustment": "بلندگو",
      "brightAdjustment": "روشنایی",
      "other": "ویژگی‌های دیگر...",
      "volumeExample": "برای سازگاری کامل با سیستم ضبط، عملکرد کامل کنترل Serial لازم است.",
      "functionCode": "عملکرد:",
      "Name": "نام:",
      "controlCode": "کد کنترل:",
      "brand": "برند:",
      "model": "مدل:",
      "errorBrandName": "برند نمی‌تواند خالی باشد!",
      "errorModelName": "مدل نمی‌تواند خالی باشد!"
    }
  },
  "roleMge": {
    "role1": "کاربر عمومی",
    "role101": "مدیر عامل نمایندگی",
    "role102": "مدیر",
    "role4": "نقش سفارشی",
    "roleNew": "نقش جدید",
    "btnAddRole": "اضافه کردن نقش",
    "chooseUser": "انتخاب کاربر",
    "titleLevel": "سطح ویژگی پخش:",
    "titleSettings": "تنظیمات مجوز:",
    "btnSave": "ذخیره",
    "btnDelete": "حذف",
    "cancel": "لغو",
    "confirm": "تأیید",
    "save": "ذخیره",
    "addSuccess": "اضافه کردن با موفقیت!",
    "addError": "اضافه کردن ناموفق!",
    "editSuccess": "ویرایش با موفقیت!",
    "editError": "ویرایش ناموفق!",
    "delSuccess": "حذف با موفقیت!",
    "delError": "حذف ناموفق!",
    "V3_0_OrganizationManage": "مدیریت گروه",
    "V3_0_UserManage": "مدیریت کاربران",
    "V3_0_DeviceManage": "مدیریت دستگاه‌ها",
    "V3_0_CloudSpaceManage": "مدیریت فضای ابری",
    "V3_0_OrganizationManage_View": "مشاهده",
    "V3_0_OrganizationManage_Edit": "ویرایش",
    "V3_0_UserManage_View": "مشاهده",
    "V3_0_UserManage_Edit": "ویرایش",
    "V3_0_DeviceManage_AddDevice": "افزودن دستگاه",
    "V3_0_DeviceManage_Operating": "عملیات",
    "V3_0_DeviceManage_Delete": "حذف",
    "V3_0_DeviceManage_Edit": "ویرایش",
    "V3_0_CloudSpaceManage_PersonalManage": "مدیریت فضای ابری شخصی",
    "V3_0_CloudSpaceManage_PublicManage": "مدیریت فضای ابری عمومی",
    "V3_0_CloudSpaceManage_SpaceManage": "اختصاص فضای ذخیره‌سازی",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "عملیات",
    "V3_0_CloudSpaceManage_PersonalManage_View": "مشاهده",
    "V3_0_CloudSpaceManage_PublicManage_View": "مشاهده",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "آپلود",
    "V3_0_CloudSpaceManage_PublicManage_Download": "دانلود",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "حذف فایل",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "ویرایش پوشه",
    "delTitle": "حذف؟",
    "delTitleContent": "محتوای انتخاب شده از پایگاه داده حذف خواهد شد. این عملیات غیرقابل بازگشت است. آیا مطمئن هستید که می‌خواهید ادامه دهید؟",
    "delCancelButton": "لغو",
    "delConfirmButton": "تأیید",
    "btnAdd": "اضافه کردن نقش",
    "RoleName": "نام نقش:",
    "ManageRange": "محدوده مدیریت:",
    "ChooseUser": "انتخاب کاربر:",
    "PermissionSettings": "تنظیمات مجوز:",
    "BroadcastingPropertyLevel": "سطح ویژگی پخش",
    "ChooseGroups": "انتخاب گروه‌ها",
    "ChooseTheUser": "انتخاب کاربر",
    "deleleTitle": "نقش جدید ذخیره نشده است. اگر از این صفحه خارج شوید، نقش حذف خواهد شد. آیا مطمئن هستید که می‌خواهید خارج شوید؟",
    "Error1601": "نقش مدیر قابل استفاده نیست",
    "Error1602": "دریافت نقش مجوز با شکست مواجه شد",
    "Error1603": "فقط مدیران به این ویژگی‌ها دسترسی دارند",
    "Error1604": "نام نقش نمی‌تواند خالی باشد",
    "Error1605": "گروه نمی‌تواند خالی باشد",
    "Error1606": "این نقش قبلاً وجود دارد",
    "Error1607": "نقش تعریف شده توسط سیستم، اصلاح آن مجاز نیست",
    "Error1608": "تنظیم نقش با شکست مواجه شد",
    "Error1609": "نقش کاربر عمومی تعریف شده توسط سیستم، اصلاح آن مجاز نیست",
    "Error1610": "لطفاً از نقش مدیر پایانه برای انجام عملیات مرتبط استفاده کنید",
    "Error1611": "هیچ مجوز مربوط به نقش وجود ندارد"
  },
  "projectorDevicesMge": {
    "tipOne": "1. نام تابع و کد کنترل را پر کنید. نمونه‌های کد کنترل از فرمت HEX استفاده می‌کنند.",
    "tipTwo": "2. این رابط فقط برای پیکربندی دستورات سریال روشن/خاموش است. لطفاً به 'مدیریت دستگاه‌ها / دستگاه‌ها / عملیات / تنظیمات برق' بروید تا تابع را فعال کنید.",
    "tipFunctionOne": "1. عملکردهای رایج را از لیست کشویی انتخاب کنید. نمادهای مربوطه در رابط کنترل سریال پنل هوشمند نمایش داده می‌شوند.",
    "tipFunctionTwo": "2. دستورات 'POWER ON' و 'POWER OFF' برای اتصال سریال روشن/خاموش دستگاه استفاده می‌شوند. این صفحه فقط کدهای کنترل را پیکربندی می‌کند. لطفاً به 'مدیریت دستگاه‌ها / دستگاه‌ها / عملیات / تنظیمات برق' بروید تا تابع اتصال را فعال کنید.",
    "ListRS232functions": "لیست عملکرد کنترل سریال",
    "Customizefunctionlist": "فهرست عملکرد را سفارشی کنید",
    "btnAddProjectorCode": "اضافه کردن کد سریال",
    "btnDel": "حذف",
    "inputSeach": "جستجو",
    "btnEdit": "ویرایش",
    "cancel": "پاکسازی",
    "confirm": "تأیید",
    "tableName": "نام کد",
    "tablersType": "نوع دستگاه:",
    "tablersTypeTable": "نوع دستگاه",
    "tableModel": "مدل",
    "tableBrand": "برند",
    "tableActions": "عملیات",
    "dialogAddTitle": "اضافه کردن کد Serial",
    "dialogEditTitle": "ویرایش کد Serial",
    "brand": "نام برند:",
    "model": "مدل:",
    "baudRate": "نرخ باند:",
    "parity": "پاریتی:",
    "powerOn": "روشن",
    "powerOff": "خاموش",
    "pgrInput1": "کانال 1",
    "pgbInput2": "کانال 2",
    "delTitle": "حذف؟",
    "delTitleContent": "محتوای انتخاب شده از پایگاه داده حذف خواهد شد. این عملیات غیرقابل بازگشت است. آیا مطمئن هستید که می‌خواهید ادامه دهید؟",
    "delCancelButton": "لغو",
    "delConfirmButton": "تأیید",
    "content": "جستجو",
    "operate": "عملیات",
    "tableDel": "حذف",
    "tableEdit": "ویرایش",
    "addSuccess": "اضافه کردن با موفقیت!",
    "addError": "اضافه کردن ناموفق!",
    "editSuccess": "ویرایش با موفقیت!",
    "editError": "ویرایش ناموفق!",
    "delSuccess": "حذف با موفقیت!",
    "delError": "حذف ناموفق!",
    "selectTitle": "لطفاً یک Serial انتخاب کنید!",
    "selectCode": "انتخاب Serial",
    "none": "هیچکدام",
    "oddParity": "پاریتی فردی",
    "EvenParity": "پاریتی زوجی"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "مدیریت گروه",
    "V3_0_UserManage": "مدیریت کاربران",
    "V3_0_DeviceManage": "مدیریت دستگاه‌ها",
    "V3_0_CloudSpaceManage": "مدیریت فضای ابری",
    "V3_0_OrganizationManage_View": "مشاهده",
    "V3_0_OrganizationManage_Edit": "ویرایش",
    "V3_0_UserManage_View": "مشاهده",
    "V3_0_UserManage_Edit": "ویرایش",
    "V3_0_DeviceManage_AddDevice": "افزودن دستگاه",
    "V3_0_DeviceManage_Operating": "عملیات",
    "V3_0_DeviceManage_Delete": "حذف",
    "V3_0_DeviceManage_Edit": "ویرایش",
    "V3_0_DeviceManage_RepairLog": "گزارش تعمیر",
    "V3_0_CloudSpaceManage_PersonalManage": "مدیریت فضای ابری شخصی",
    "V3_0_CloudSpaceManage_PublicManage": "مدیریت فضای ابری عمومی",
    "V3_0_CloudSpaceManage_SpaceManage": "مدیریت فضای ابری",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "عملیات",
    "V3_0_CloudSpaceManage_PersonalManage_View": "مشاهده",
    "V3_0_CloudSpaceManage_PublicManage_View": "مشاهده",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "بارگذاری",
    "V3_0_CloudSpaceManage_PublicManage_Download": "دانلود",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "حذف",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "ویرایش",
    "delTitle": "حذف؟",
    "delTitleContent": "اجزای انتخاب شده از پایگاه داده حذف خواهند شد. این فرآیند غیرقابل برگشت است. آیا مطمئن هستید که می‌خواهید ادامه دهید؟",
    "delCancelButton": "لغو",
    "delConfirmButton": "تأیید",
    "content": "جستجو",
    "operate": "عملیات",
    "tableDel": "حذف",
    "tableEdit": "ویرایش",
    "addSuccess": "اضافه شد!",
    "addError": "افزودن ناموفق بود!",
    "editSuccess": "ویرایش موفقیت‌آمیز!",
    "editError": "ویرایش ناموفق بود!",
    "delSuccess": "حذف موفقیت‌آمیز!",
    "delError": "حذف ناموفق بود!",
    "selectTitle": "لطفاً Serial را انتخاب کنید!"
  },
  "workstationMge": {
    "priorChoice": "ترجیحات پخش:",
    "SpeedPriority": "اولویت سرعت",
    "SyncPriority": "اولویت همگام‌سازی فریم",
    "SpeedPriorityTip": "پس از ارسال دستورالعمل‌های پخش AV، ترمینال‌های Q-NEX می‌توانند وظایف پخش را با زمان بافر حدود 3-5 ثانیه انجام دهند. اولویت سرعت زمانی که سرور رسانه در شبکه محلی (LAN) کار می‌کند، بسیار توصیه می‌شود.",
    "SyncPriorityTip": "پس از ارسال دستورالعمل‌های پخش AV، ترمینال‌های Q-NEX می‌توانند وظایف پخش را به طور همزمان با زمان بافر حدود 8-12 ثانیه انجام دهند.",
    "btnAddMedia": "افزودن سرور رسانه",
    "btnBack": "بازگشت",
    "tableMediaLibId": "شناسه سرور رسانه",
    "tableMediaLibName": "نام سرور رسانه",
    "tableState": "وضعیت شبکه",
    "tableBindingUsers": "کاربران متصل",
    "tableLiveAddress": "آدرس استریم",
    "tableAddress": "آدرس پخش",
    "tableOperate": "عملیات",
    "tableDel": "حذف",
    "tableEdit": "ویرایش",
    "titleMediaStation": "آدرس پخش",
    "titleLiveStation": "آدرس استریم:",
    "radioPublic": "عمومی",
    "radioPrivate": "خصوصی",
    "btnSave": "ذخیره",
    "titleUsers": "کاربران",
    "titleCanBe": "قابل اتصال",
    "titleHaveBeen": "اتصال یافته",
    "titleMore": "آیا نیاز به افزودن بیشتر دارید؟",
    "btnAdd": "افزودن",
    "content": "جستجو",
    "tableName": "نام",
    "tableUserName": "نام کاربری",
    "operate": "عملیات",
    "affiliatedOrganization": "گروه‌ها",
    "dialogTitle": "افزودن سرور رسانه جدید",
    "dialogTitleEdit": "ویرایش سرور رسانه جدید",
    "dialogItemName": "نام:",
    "dialogItemId": "شناسه:",
    "dialogItemIp": "آدرس پخش:",
    "titleSelectUsers": "انتخاب کاربران",
    "selectMedia": "لطفاً رسانه را انتخاب کنید",
    "delTitle": "آیا مطمئن هستید که می‌خواهید حذف کنید؟",
    "delMediaLibTitle": "تأیید حذف؟",
    "delTitleContent": "محتویات انتخاب شده از پایگاه داده حذف خواهند شد. این عملیات قابل بازگشت نیست. آیا مطمئن هستید که می‌خواهید ادامه دهید؟",
    "delTitleMediaLibContent": "عملیات حذف باعث پاک شدن داده‌های مرتبط خواهد شد و قابل برگشت نیست.",
    "delCancelButton": "لغو",
    "delConfirmButton": "تأیید",
    "selectDevices": "لطفاً دستگاه‌ها را انتخاب کنید",
    "selectUser": "لطفاً کاربران را انتخاب کنید",
    "addUser": "افزودن کاربر",
    "editUser": "ویرایش کاربر",
    "addSuccess": "با موفقیت اضافه شد!",
    "addError": "افزودن ناموفق بود!",
    "editSuccess": "با موفقیت ویرایش شد!",
    "editError": "ویرایش ناموفق بود!",
    "delSuccess": "با موفقیت حذف شد!",
    "delError": "حذف ناموفق بود!",
    "cancel": "لغو",
    "confirm": "تأیید",
    "save": "ذخیره",
    "error2500": "تعداد دستگاه‌هایی که می‌توانند به ایستگاه کاری فعلی متصل شوند، از حد مجاز فراتر رفته است.",
    "DeviceName": "نام دستگاه",
    "AssociatedUserManagement": "مدیریت کاربران مرتبط",
    "btnDel": "حذف",
    "errorMsgId": "این شناسه پیدا نشد",
    "LiveStreaming": "آدرس استریم:",
    "NoFoundMediaId": "نتوانستیم شناسه سرور رسانه را بدست آوریم",
    "AlreadyConnectedOrg": "سرور رسانه قبلاً با سازمان دیگری مرتبط است",
    "AlreadyBoundMedia": "این سازمان قبلاً یک سرور رسانه را متصل کرده است و نمی‌تواند یکی دیگر متصل کند",
    "DeleteSecondaryConfirmation": "پس از حذف سرور رسانه، داده‌ها قابل بازیابی نخواهند بود، لطفاً دوباره تأیید کنید."
  },
  "cloudDiskMge": {
    "totalStorage": "مجموع فضای ذخیره‌سازی",
    "GetMore": "بیشتر دریافت کنید",
    "StorageSpace": "فضای ذخیره‌سازی",
    "Adjustment": "تنظیمات",
    "moreSpace": "فضای ذخیره‌سازی بیشتر دریافت کنید",
    "PublicStorage": "فضای ذخیره‌سازی عمومی",
    "PublicStorageUsed": "فضای ذخیره‌سازی عمومی استفاده شده",
    "PublicStorageLasted": "فضای ذخیره‌سازی عمومی باقی‌مانده",
    "IndividualStorageUsed": "فضای ذخیره‌سازی شخصی استفاده شده",
    "IndividualStorageLasted": "فضای ذخیره‌سازی شخصی باقی‌مانده",
    "storageSpace": "تنظیمات فضای ذخیره‌سازی",
    "tableUserName": "نام کاربری",
    "tableUsedSpace": "فضای استفاده شده",
    "tableAvailableSpace": "فضای قابل دسترس",
    "tableActiveTime": "آخرین زمان فعالیت",
    "tableOperate": "عملیات",
    "cleanup": "یادداشت برای پاکسازی",
    "IndividualStorageSpaceAdjustment": "تنظیمات فضای ذخیره‌سازی شخصی",
    "titleTotal": "مجموع",
    "PublicDisk": "فضای ذخیره‌سازی عمومی",
    "IndividualDisk": "فضای ذخیره‌سازی شخصی",
    "PerUser": "بر اساس کاربر",
    "UsersInTotal": "تعداد کل کاربران",
    "cancel": "لغو",
    "confirm": "تأیید",
    "save": "ذخیره",
    "addSuccess": "با موفقیت اضافه شد!",
    "addError": "افزودن ناموفق بود!",
    "editSuccess": "ویرایش با موفقیت انجام شد!",
    "editError": "ویرایش ناموفق بود!",
    "delSuccess": "با موفقیت حذف شد!",
    "delError": "حذف ناموفق بود!",
    "error3000": "عملیات شکست خورد، زیرا حجم کل ذخیره‌سازی از حد مجاز بیشتر شده است.",
    "error3003": "عملیات ناموفق بود، لطفاً بررسی کنید که آیا یک سرور رسانه‌ای تنظیم شده است.",
    "IndividualStorage": "فضای ذخیره‌سازی شخصی",
    "NoteToCleanup": "یادداشت برای پاکسازی",
    "updatePersonalSuccess": "فضای ذخیره‌سازی ابری شما پر خواهد شد، لطفاً به موقع پاکسازی کنید",
    "updatePersonalSuccess1": "با موفقیت ویرایش و ذخیره شد",
    "storageUsage": "استفاده از فضای ذخیره‌سازی شخصی",
    "bindIndividualstorage": "کاربرانی که مجاز به داشتن فضای ذخیره‌سازی ابری شخصی هستند",
    "UserIndividualstorage": "کاربرانی که فضای ذخیره‌سازی ابری شخصی تنظیم کرده‌اند",
    "Notificationsuccessfully": "اطلاعیه با موفقیت ارسال شد",
    "Notificationfailed": "ارسال اطلاعیه ناموفق بود",
    "tableName": "نام",
    "userID": "شناسه کاربری"
  },
  "dashboard": {
    "exportPdf": "خروجی PDF",
    "or": "-",
    "warrantyCompletionRate": "نرخ تکمیل تعمیر",
    "frequencyOfEachModule": "درصد تعمیر هر ماژول عملکردی",
    "repairHandling": "وضعیت پردازش تعمیر",
    "sourceSwitchInput": "سوئیچ ورودی",
    "micVol": "حجم میکروفون",
    "volumeSpeaker": "حجم بلندگو",
    "airAonditioner": "کولر",
    "Curtain": "صفحه نمایش پروژکتور",
    "remoteControlIntelligent": "کنترل از راه دور",
    "RS232Control": "کنترل Serial",
    "lockElectronic": "قفل‌های الکترونیکی",
    "Repairreportcompleted": "تعمیر شده",
    "Totalnumberofrepairsreported": "تعمیرات کل",
    "Warrantycompletionrate": "نرخ تکمیل تعمیر",
    "startDate": "تاریخ شروع",
    "endDate": "تاریخ پایان",
    "year": "سال",
    "month": "ماه",
    "dayTian": "روز",
    "placeholderDate": "انتخاب تاریخ",
    "placeholderDateTime": "انتخاب زمان",
    "devicesNub": "دستگاه‌ها",
    "userNub": "کاربران",
    "powerNub": "توان (کیلووات/ساعت)",
    "storageUsed": "فضای ذخیره‌سازی استفاده شده (%)",
    "userLoginDevice": "دوره زمانی فعالیت ورود به سیستم کاربر",
    "devicePowerConsumption": "مصرف روزانه برق همه دستگاه‌ها",
    "externalDeviceUsageTime": "استفاده از دستگاه‌های خارجی",
    "equipmentRunningTime": "استفاده از دستگاه‌های ترمینالی",
    "cloudStorageSpace": "استفاده از فضای ذخیره‌سازی",
    "powerConsumptionPort": "مصرف برق هر پورت برق",
    "mostPopularFile": "پرطرفدارترین فایل",
    "commonFunctions": "عملکردهای رایج",
    "commonlyUsed": "روش‌های پخش رایج",
    "fileName": "نام فایل",
    "usageCount": "تعداد استفاده",
    "electricityConsumption": "مصرف برق",
    "publicStorageUsed": "فضای ذخیره‌سازی عمومی استفاده شده",
    "publicStorageLasted": "فضای ذخیره‌سازی عمومی باقی‌مانده",
    "individualStorageUsed": "فضای ذخیره‌سازی شخصی استفاده شده",
    "individualStorageLasted": "فضای ذخیره‌سازی شخصی باقی‌مانده",
    "notification": "اطلاعیه",
    "audioBroadcast": "پخش صوتی",
    "videoBroadcast": "پخش ویدئویی",
    "ac": "کولر",
    "hDMISwitch": "سوئیچ HDMI",
    "powerControl": "کنترل برق",
    "powercontrol": "کنترل برق",
    "Lock": "قفل",
    "volumeAdjust": "تنظیم حجم صدا",
    "projectionScreen": "صفحه نمایش پروژکتور",
    "today": "امروز",
    "yesterday": "دیروز",
    "thisWeek": "این هفته",
    "lastWeek": "هفته گذشته",
    "lastMonth": "ماه گذشته",
    "thisMonth": "این ماه",
    "times": "بار",
    "usage": "تعداد استفاده",
    "eachrTitle": "دقیقه",
    "total": "مجموع",
    "NMPSystemissue": "مشکل سیستم NMP",
    "displayPower": "مشکل دستگاه خارجی NMP",
    "externalPower": "مشکل سیستم MBX",
    "screen": "مشکل دستگاه خارجی MBX",
    "TotalRepairs": "تعمیرات کل",
    "Repaired": "تعمیر شده",
    "Unrepaired": "تعمیر نشده",
    "day": "روز",
    "Minutes": "دقیقه",
    "powerConsumption": "دقیقه",
    "Date": "تاریخ",
    "kw": "کیلووات",
    "month1": "دوشنبه",
    "month2": "سه‌شنبه",
    "month3": "چهارشنبه",
    "month4": "پنج‌شنبه",
    "month5": "جمعه",
    "month6": "شنبه",
    "month7": "یکشنبه",
    "enmonth1": "ژانویه",
    "enmonth2": "فوریه",
    "enmonth3": "مارس",
    "enmonth4": "آوریل",
    "enmonth5": "مه",
    "enmonth6": "ژوئن",
    "enmonth7": "ژوئیه",
    "enmonth8": "آگوست",
    "enmonth9": "سپتامبر",
    "enmonth10": "اکتبر",
    "enmonth11": "نوامبر",
    "enmonth12": "دسامبر",
    "noData": "بدون داده"
  },
  "input": {
    "fivedigits": "لطفاً یک عدد صحیح مثبت وارد کنید که حداکثر 5 رقم باشد",
    "titlUserNameField": "این نام کاربری باید پر شود.",
    "thisField": "این فیلد باید پر شود.",
    "ChooseGroup": "گروه را انتخاب کنید",
    "placeholder": "انتخاب",
    "placeholder_type": "لطفاً نوع‌های کنترل دستگاه را انتخاب کنید",
    "titlRealNameField": "کلمه عبور باید پر شود.",
    "thisPasswordField": "کلمه عبور باید پر شود.",
    "titlPassWordNub": "کمتر از 15 حرف",
    "Post": "فقط اعداد",
    "passwordNoChinese": "این کادر ورودی نمی‌تواند با کاراکترهای چینی پر شود"
  },
  "transfer": {
    "all": "همه",
    "Choose": "انتخاب کنید",
    "Selected": "انتخاب شده",
    "Subordinate": "زیرمجموعه"
  },
  "setting": {
    limitPngGif: 'فقط فرمت‌های PNG / GIF پشتیبانی می‌شوند',
    limit3M: 'حجم تصویر نباید بیشتر از ۳ مگابایت باشد',
    setting_door_Wallpaper_text: 'اندازه پیشنهادی تصویر: 1280x800، با فرمت PNG یا GIF',
    "reduction": "بازگردانی",
    "limitJpg": "تصویر پروفایل بارگذاری‌شده فقط باید در فرمت PNG باشد!",
    "limit2M": "حجم تصویر پروفایل بارگذاری‌شده نباید بیش از ۲MB باشد!",
    "choseFile": "فایل را انتخاب کنید",
    "textOne": "۱. تصویر لوگوی پیشنهادی: اندازه ۱۱۷*۴۰، در فرمت PNG",
    "textTwo": "۲. پس از اتمام آپلود، لطفاً به پنل لمسی بروید و اطمینان حاصل کنید که پنل لمسی به اینترنت متصل است، سپس بر روی لوگوی اصلی کلیک کنید تا به‌روزرسانی شود.",
    "customizeLogo": "تنظیمات لوگوی پنل لمسی",
    "addSuccess": "تنظیمات با موفقیت انجام شد!",
    "settingIp": "تنظیمات IP ذخیره‌سازی فایل",
    "ServerIP": "آدرس IP سرور:",
    "ServerPort": "پورت سرور:",
    "btnSave": "ذخیره‌سازی",
    "TimeZoneSetting": "تنظیمات منطقه زمانی",
    "CurrentTime": "زمان فعلی:",
    "CurrentTimeZone": "منطقه زمانی فعلی:",
    "httpsSetting": "ذخیره‌سازی فایل:",
    "utcName": "زمان استاندارد گرینویچ UTC/GMT",
    "utc0": "زمان استاندارد گرینویچ، انگلستان، لیسبون، تورشافن، لندن، دوبلین، ادینبورگ",
    "utc0_5": "",
    "utc1": "اروپای مرکزی، غرب آفریقا، آفریقای مرکزی غربی، آلمان، ایرلند، فرانسه، آمستردام، ایتالیا، برلین، رم، اسپانیا، پراگ، بلگراد، بروکسل، پاریس، مادرید، تونس، گابن، مراکش",
    "utc1_5": "",
    "utc2": "اروپای شرقی، آفریقا مرکزی، ترکیه، اسرائیل، آفریقای جنوبی، استانبول، قاهره، آتن، دمشق",
    "utc2_5": "",
    "utc3": "شرق آفریقا، روسیه، بغداد، کویت، مسکو، سن‌پترزبورگ",
    "utc3_5": "ایران",
    "utc4": "ابوظبی، تفلیس، دبی، موریس، پورت لوئیس",
    "utc4_5": "افغانستان",
    "utc5": "پاکستان، ترکمنستان، مالدیو، ازبکستان، ارمنستان، تاجیکستان هند، بمبئی، دهلی نو، بنگلور، کلکته",
    "utc5_5": "هند، سریلانکا",
    "utc6": "نووسیبیرسک، قرقیزستان، بنگلادش، بوتان",
    "utc6_5": "جزایر کک استرالیا، ویتنام",
    "utc7": "تایلند، بانکوک، هانوی، جاکارتا",
    "utc7_5": "",
    "utc8": "چین، مالزی، فیلیپین، سنگاپور، تایوان چین، ماکائو چین، هنگ کنگ چین",
    "utc8_5": "",
    "utc9": "ژاپن، کره جنوبی، توکیو، سئول، ساپورو، اوساکا، تیمور شرقی",
    "utc9_5": "زمان استاندارد استرالیای مرکزی",
    "utc10": "استرالیا، ولادیوستوک، گوام، کانبرا، ملبورن، سیدنی، پاپوآ گینه نو",
    "utc10_5": "جزیره لرد هاو از نیو ساوت ولز، استرالیا",
    "utc11": "جزایر سولوومون، جزیره ساخالین",
    "utc11_5": "جزیره نورفولک، استرالیا",
    "utc12": "نیوزیلند، آکلند، ولینگتون، فیجی، نیوزیلند، نائورو",
    "utc12_5": "",
    "utc13": "جزایر کیپ ورد، آزور",
    "utc13_5": "",
    "utc14": "جزایر جورجیا جنوبی، فرناندو د نورنها",
    "utc14_5": "",
    "utc15": "برزیل، سانتیاگو، السالوادور، برازیلیا، اروگوئه، آرژانتین، سورینام",
    "utc15_5": "زمان استاندارد نیوفاندلند",
    "utc16": "ونزوئلا، بولیوی، پاراگوئه، شیلی",
    "utc16_5": "ونزوئلا",
    "utc17": "زمان شرقی (آمریکا و کانادا)، کلمبیا، تورنتو، اکوادور، پرو، کوبا، نیویورک، همیلتون، سن‌دیگو",
    "utc17_5": "",
    "utc18": "زمان استاندارد آمریکای شمالی و کانادا، مکزیکو سیتی، مونتری، شیکاگو، هیوستون، نیو اورلئانز، ممفیس",
    "utc18_5": "",
    "utc19": "زمان استاندارد کوهستانی، آریزونا، مازاتلان، فینیکس، سالت لیک سیتی، دنور، ادمونتون",
    "utc19_5": "",
    "utc20": "زمان استاندارد اقیانوس آرامی، لس آنجلس، سان فرانسیسکو، ونکوور، سیاتل، لاس وگاس",
    "utc20_5": "",
    "utc21": "آلاسکا",
    "utc21_5": "پلی‌نزی فرانسه، جزایر مارکاز",
    "utc22": "هاوایی",
    "utc22_5": "",
    "utc23": "ساموآ، نیو",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "نام دستگاه:",
    "Time": "زمان:",
    "startDate": "تاریخ شروع",
    "endedDate": "تاریخ پایان",
    "or": "-",
    "Problem": "مشکل:",
    "btnSearch": "جستجو",
    "tableNO": "خیر",
    "tableDeviceName": "نام دستگاه",
    "tableGroup": "گروه",
    "tableStatus": "وضعیت",
    "tableDeliveredTime": "زمان تحویل",
    "tableSubmitter": "فرستنده",
    "tableUpdatingTime": "زمان بروزرسانی",
    "tableProblem": "مشکل",
    "tableAdmin": "مدیر IT",
    "tableAdminReply": "پاسخ مدیر",
    "tableAttachment": "پیوست",
    "state0": "تحویل داده شده",
    "state1": "در حال پردازش",
    "state2": "تکمیل شده",
    "Problem100": "همه",
    "Problem0": "مشکل سیستم",
    "Problem1": "مشکل دستگاه خارجی",
    "ProblemType": "",
    "ProblemType0": "کنترل برق",
    "ProblemType1": "سوییچ HDMI",
    "ProblemType2": "میکروفن",
    "ProblemType3": "بلندگو",
    "ProblemType4": "کولر",
    "ProblemType5": "صفحه نمایش پروژکتور",
    "ProblemType6": "قفل الکتریکی",
    "ProblemType7": "پخش A/V",
    "ProblemType8": "کنترل IR",
    "ProblemType9": "کنترل Serial",
    "dialogDeviceName": "نام دستگاه",
    "dialogDeviceID": "شناسه دستگاه",
    "dialogGroup": "گروه",
    "dialogSubmitter": "فرستنده",
    "dialogStatus": "لطفا وضعیت را انتخاب کنید",
    "dialogProblem": "مشکل",
    "dialogNotes": "یادداشت‌ها",
    "dialogRepairation": "تعمیر",
    "dialogInProcess": "در حال پردازش",
    "dialogCompleted": "تکمیل شده",
    "editSuccess": "ویرایش موفقیت‌آمیز!",
    "editError": "ویرایش ناموفق!",
    "problemRequired": "لطفا نوع مشکل را انتخاب کنید",
    "detailRequired": "لطفا مشکل را به طور کامل شرح دهید",
    "statusRequired": "لطفا وضعیت گزارش را انتخاب کنید",
    "btnCancel": "لغو",
    "DeliveredTime": "زمان تحویل",
    "UpdatingTime": "زمان بروزرسانی",
    "ITAdmin": "مدیر IT",
    "AdminReply": "پاسخ مدیر",
    "Note": "یادداشت",
    "Detail": "جزئیات",
    "controlPanel": "پنل کنترل",
    "DeviceType": "نوع",
    "dialogDeliveredTime": "زمان تحویل",
    "Submitter": "فرستنده"
  },
  "remoteControl": {
    "QuickActionName": "نام",
    "DeviceType": "نوع",
    "Description": "توضیحات",
    "tableDescription": "توضیحات",
    "editRemoteControl": "ویرایش کد کنترل از راه دور",
    "QuickActionNameInput": "نام",
    "DescriptionInput": "توضیحات",
    "save": "ذخیره",
    "Brand": "برند",
    "Model": "مدل",
    "EditACControlCode": "ویرایش کد کنترل کولر",
    "acBrand": "برند کولر",
    "acModel": "مدل کولر"
  },
  "card": {
    "btnAddCard": "اضافه کردن کارت",
    "btnBatchAddCard": "افزودن دسته‌ای کارت‌ها",
    "tableCard": "شماره کارت",
    "tableState": "وضعیت",
    "tableUser": "دستگاه مرتبط با کاربر",
    "tableID": "نام کاربری",
    "tableType": "نوع کارت",
    "tableFfective": "تاریخ انقضا",
    "dialogCard": "شماره کارت:",
    "dialogState": "وضعیت:",
    "dialogUser": "دستگاه مرتبط با کاربر:",
    "dialogID": "نام کاربری:",
    "dialogType": "نوع کارت:",
    "dialogFfective": "تاریخ انقضا:",
    "dialogRemarks": "یادداشت:",
    "dialogAddTitle": "اضافه کردن کارت",
    "dialogEidtTitle": "ویرایش کارت",
    "code2201": "فرمت تاریخ انقضای کارت اشتباه است",
    "code2202": "این کارت قبلاً به یک کاربر مرتبط شده است",
    "code2203": "این کاربر قبلاً مرتبط شده است",
    "code2204": "این کارت به هیچ کاربری مرتبط نشده است",
    "mastCard": "کارت اصلی",
    "regularCard": "کارت عمومی",
    "permanent": "دائمی",
    "coxPermanent": "دائمی",
    "coxTime": "یک بازه زمانی خاص",
    "tableDeviceName": "نام دستگاه",
    "tableDeviceID": "شناسه دستگاه",
    "tableOperating": "عملیات",
    "tableOperatingTime": "زمان انجام عملیات",
    "tableCardID": "شماره کارت",
    "tableCardType": "نوع کارت",
    "tabluserName": "نام کاربری",
    "tabluserId": "شناسه کاربر",
    "unlockPanel": "باز کردن پنل",
    "unlock": "باز کردن درب",
    "conAll": "همه",
    "btnEnable": "فعال کردن",
    "btnDisable": "غیرفعال کردن",
    "enableSuccess": "فعال شدن با موفقیت",
    "stopSuccess": "غیرفعال شدن با موفقیت",
    "enableError": "فعال شدن ناموفق",
    "stopError": "غیرفعال شدن ناموفق",
    "batchCard": "شماره دسته کارت:",
    "titlCardField": "شماره کارت نمی‌تواند خالی باشد",
    "titlCardFieldFormat": "فقط حروف و اعداد",
    "dialogBachAddTitle": "افزودن دسته‌ای کارت‌ها",
    "pleaseTryAgain1": "شماره کارت اشتباه است (شماره :",
    "pleaseTryAgain2": ")، لطفاً دوباره تلاش کنید"
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/fa.js